import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function AutorenewIcon(props: IconProps) {
    return <Icon {...props} iconKey={"autorenew"}/>
}
